import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import LocalStorageBackend from 'i18next-localstorage-backend';
import ChainedBackend from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend';

const isDevelopment = import.meta.env.DEV === true;

i18n
  // i18next-http-backend
  // loads translations from your server
  // https://github.com/i18next/i18next-http-backend
  .use(ChainedBackend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: isDevelopment,
    // lng: 'pt-BR', // idioma padrão
    fallbackLng: 'pt-BR',
    load: 'languageOnly',
    defaultNS: 'translation',
    ns: ['translation', 'common', 'sidebar', 'userGoOn'],
    interpolation: {
      escapeValue: false
    },
    backend: {
      backends: [LocalStorageBackend, HttpBackend],
      backendOptions: [
        {
          expirationTime: 7 * 24 * 60 * 60 * 1000 // 7 dias
        },
        {
          loadPath: '/locales/{{ns}}/{{lng}}.json'
        }
      ],
      cacheHitMode: 'refreshAndUpdateStore',
    },

    react: {
      bindI18nStore: 'added', // this way, when the HttpBackend delivers new translations (thanks to refreshAndUpdateStore), the UI gets updated
    },
  });

export default i18n; 